import { Component, Input, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { FormType, NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES, createForm, subformComponentProviders } from "ngx-sub-form";
import { Subject } from "rxjs";
import { User, UserProfile } from "./user-model";


@Component({
  selector: 'app-user-profile-form',
  styles: [``],
  template: `
      <form (mouseover)="populateOrganization()" [formGroup]="form.formGroup">
        <div class="flex flex-col space-y-2">

          <div class="flex flex-col">
            <label>Email</label>
            <input class="w-full" type="email" pInputText [formControlName]="form.formControlNames.email" (blur)="emailOnBlur()" />
            @if (!form.formGroup.controls.email.value && form.formGroup.controls.email.errors?.['required']) {
              <p class="validation-error">Email is required.</p>
            }
            @if (form.formGroup.controls.email.value && form.formGroup.controls.email.invalid) {
              <p class="validation-error">Email is invalid.</p>
            }
          </div>

          <div class="flex flex-col">
            <label>First Name</label>
            <input class="w-full" type="text" pInputText [formControlName]="form.formControlNames.firstName" />
            @if (form.formGroup.controls.firstName.errors?.['required']) {
              <p class="validation-error">First Name is required.</p>
            }
          </div>

          <div class="flex flex-col">
            <label>Last Name</label>
            <input class="w-full" type="text" pInputText [formControlName]="form.formControlNames.lastName" />
            @if (form.formGroup.controls.lastName.errors?.['required']) {
              <p class="validation-error">Last Name is required.</p>
            }
          </div>

          <div class="flex flex-col">
            <label>Organization</label>
            <p-select class="w-full" appendTo="body" [options]="organizations" filter resetFilterOnHide="true" [formControlName]="form.formControlNames.organization"></p-select>
            @if (form.formGroup.controls.organization.errors?.['required']) {
              <p class="validation-error">Organization is required.</p>
            }
          </div>

          <div class="flex flex-col">
            <label>Job Title</label>
            <input class="w-full" type="text" pInputText [formControlName]="form.formControlNames.jobTitle" />
          </div>

          @if (showAdminInputs) {
            <p-fieldset legend="Global Admin Only">
              <div class="flex flex-col mb-2">
                <label>Database</label>
                <p-select class="w-full" appendTo="body" [options]="organizations" filter resetFilterOnHide="true" [formControlName]="form.formControlNames.database"></p-select>
                @if (form.formGroup.controls.database.errors?.['required']) {
                  <p class="validation-error">Database is required.</p>
                }
              </div>

              <div class="flex">
                <p-checkbox
                  size="small"
                  binary="true"
                  [formControlName]="form.formControlNames.isGlobalAdmin"
                  inputId="isGlobalAdmin"
                ></p-checkbox>
              <label for="isGlobalAdmin" class="ml-2"> Global Admin</label>
            </div>

            </p-fieldset>
          }
        </div>
      </form>
      <br/>
    `,
  providers: subformComponentProviders(UserProfileFormComponent),
  standalone: false
})
export class UserProfileFormComponent {

  private input$ = new Subject<UserProfile | undefined>();
  private _showAdminInputs: boolean;

  public organizations: string[] = ["Altus", "Baker", "Bp", "Bsee", "Cop", "Fervo", "Harbour", "InpexAu", "Neptune", "Omv", "Ormat", "Oxy", "Ou", "Petronas", "Sage", "Shell", "Slb", "Te"];

  @Input() set userProfile(userProfile: UserProfile | undefined) {
    this.input$.next(userProfile);
  }

  @Input()
  user: User;

  @Input() set showAdminInputs(value: boolean) {
    this._showAdminInputs = value;
  }
  get showAdminInputs(): boolean {
    return this._showAdminInputs;
  }

  private disabled$ = new Subject<boolean>();
  @Input() set disabled(value: boolean | undefined) {
    this.disabled$.next(!!value);
  }

  @Output() userProfileUpdated = new Subject<UserProfile>();

  @Output() emailChanged = new Subject<string>();

  public emailOnBlur() {
    if (this.form.formGroup.controls.email.valid) {
      this.emailChanged.next(this.form.formGroup.controls.email.value)
    }
  }

  public form = createForm<UserProfile, UserProfile>(this, {
    formType: FormType.SUB,
    disabled$: this.disabled$,
    input$: this.input$,
    output$: this.userProfileUpdated,
    formControls: {
      email: new UntypedFormControl(null, [Validators.required, Validators.email]),
      firstName: new UntypedFormControl(null, Validators.required),
      lastName: new UntypedFormControl(null, Validators.required),
      organization: new UntypedFormControl(null, Validators.required),
      jobTitle: new UntypedFormControl(null),
      database: new UntypedFormControl(null, Validators.required),
      isGlobalAdmin: new UntypedFormControl(false)
    },
    handleEmissionRate: NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES.debounce(1000)
  });

  populateOrganization() {
    if (!this.form.formGroup.controls.organization.value) {
      this.form.formGroup.controls.database.setValue(this.user.profile.database.slice(0, -2)); // Remove 'Db' from name
    }

    if (this.user?.profile.organization != "Altus" || !this.showAdminInputs) {
      this.form.formGroup.controls.organization.setValue(this.user.profile.organization);
      this.form.formGroup.controls.organization.disable();
      this.form.formGroup.controls.database.disable();
      this.form.formGroup.controls.isGlobalAdmin.disable();
    }
  }
}
